"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _common = require("../utils/common");
var _lego = _interopRequireDefault(require("../lego"));
var _log = _interopRequireDefault(require("../utils/log"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// 定义商品曝光埋点名称和商品所在区域的名称
var GOODS_EXPOSURE_NAME = 'lego-goods-exposure';
var SECTION_ID_NAME = 'zz-sectionid';

// 判断是否在服务端
var isServer = typeof window === 'undefined';
// 默认的 debounce 时间，用户停留 1 秒后，上报此次埋点
var delayTime = 1000;
// 用于标识每一次的会话 ID
var rstmark = new Date().getTime();
// 页面基础信息
var pageIdInfo = {};
// 缓存的商品信息，结构为 { infoId: xxx, index: xxx }
var cachedGoodInfo = new Map();
// 已经曝光过的商品
var hasExposureGoods = new Map();
// 支持维护多个 sectionId 与 rstmark 进行曝光
var sessionIdMap = new Map();
// 发送商品曝光埋点
var sendGoodsExposure = function sendGoodsExposure(params, callback) {
  return (0, _common.debounce)(function () {
    // 获取本次需要上报的商品信息
    var resultGoodInfo = JSON.parse(JSON.stringify(cachedGoodInfo.get(params.targetContainer) || []));

    // 缓存清空
    cachedGoodInfo.delete(params.targetContainer);

    // 去重，过滤掉本次重复的商品
    resultGoodInfo = (0, _common.uniqueObj)(resultGoodInfo);

    // 去重，过滤掉已经曝光过的商品
    var reportGoods = resultGoodInfo.filter(function (item) {
      if ((hasExposureGoods.get(params.targetContainer) || []).some(function (good) {
        return good.infoId === item.infoId && good.index === item.index;
      })) {
        return false;
      }
      return true;
    });

    // 如果有需要上报的商品，则发送埋点
    if (reportGoods.length > 0) {
      reportGoodsLego(reportGoods, params, callback);
    }

    // 合并已曝光的商品和本次要上报的商品，并去重
    var res = (0, _common.uniqueObj)((hasExposureGoods.get(params.targetContainer) || []).concat(reportGoods));

    // 更新已曝光的商品
    hasExposureGoods.set(params.targetContainer, res);
  }, delayTime);
};

// 发送商品曝光埋点的逻辑
var reportGoodsLego = function reportGoodsLego(reportGoods, params, callback) {
  // 解构 params 中的 extraParam 和 sectionId
  var extraParam = params.extraParam,
    sectionId = params.sectionId;

  // 默认使用 rstmark 作为会话 ID
  var _rstmark = rstmark;

  // 如果 sessionIdMap 中有值，则使用 sectionId 对应的 rstmark
  if (sessionIdMap.size) {
    _rstmark = sessionIdMap.get(sectionId) || rstmark;
  }

  // 定义埋点参数
  var obj = {};
  obj.pagetype = 'explosureGoods';
  obj.actiontype = pageIdInfo.pageId;

  // 如果 actiontype 为空，则抛出错误
  if (!obj.actiontype) {
    _log.default.error('[Lego - legoGoodsExposure] 请先配置好pageId');
    return;
  }

  // 设置埋点参数 backup
  obj.backup = Object.assign({}, _objectSpread(_objectSpread({}, extraParam), {}, {
    sectionId: sectionId,
    rstmark: _rstmark,
    goodsList: reportGoods.map(function (item) {
      return item.infoId;
    }).join('&'),
    indexList: reportGoods.map(function (item) {
      return item.index;
    }).join('&')
  }), reportGoods[0].isBannerBarList !== undefined ? {
    isBannerBarList: reportGoods.map(function (item) {
      return item.isBannerBarList;
    }).join('&')
  } : {});

  // 发送埋点
  _lego.default.send(obj, callback);
};

// 获取容器内的需要曝光的元素
var getGoodsTarget = function getGoodsTarget(ele) {
  if (!ele) return [];
  return Array.from(ele.querySelectorAll("[".concat(GOODS_EXPOSURE_NAME, "]")));
};

// 维护所有 IntersectionObserver 事例， 防止重复
var ISObserverMap = new WeakMap();
var startListenExposure = function startListenExposure(params, callback) {
  var _params$targetGoods = params.targetGoods,
    targetGoods = _params$targetGoods === void 0 ? [] : _params$targetGoods,
    targetContainer = params.targetContainer;
  var ioPromise = (0, _common.checkIntersectionObserver)() ? Promise.resolve() : Promise.resolve().then(function () {
    return _interopRequireWildcard(require('intersection-observer'));
  });
  ioPromise.then(function () {
    var newISObserver = new IntersectionObserver(function (entries) {
      // 元素出现在可视区的操作逻辑
      var goodInfo = {};
      entries.forEach(function (entry) {
        // console.log('IntersectionObserver - entry', entry.target, entry.intersectionRatio)
        // 可见元素的可见比例大于0
        if (entry.intersectionRatio && entry.intersectionRatio > 0) {
          goodInfo = entry.target.getAttribute(GOODS_EXPOSURE_NAME);
          if (!goodInfo) return;
          try {
            goodInfo = JSON.parse(goodInfo);
          } catch (e) {
            _log.default.error("[Lego - legoGoodsExposure] \u5546\u54C1\u6570\u636E\u683C\u5F0F\u9519\u8BEF\uFF0C\u65E0\u6CD5\u8F6C\u6362\u4E3AJS\u5BF9\u8C61\uFF0C\u8BF7\u68C0\u67E5\u3002\u9519\u8BEF\u6570\u636E\uFF1A'".concat(goodInfo));
            goodInfo = {};
          }
          var old = cachedGoodInfo.get(targetContainer);
          if (!old) {
            cachedGoodInfo.set(params.targetContainer, [goodInfo]);
          } else {
            old.push(goodInfo);
          }
          sendGoodsExposure(params, callback)();
        }
      });
    }, {
      threshold: 0.5 // 元素50%显示时，即认为出现在了可视区
    });

    targetGoods.forEach(function (item) {
      return newISObserver.observe(item);
    });
    ISObserverMap.set(targetContainer, newISObserver);
  });
};

// 维护所有 MutationObserver 实例 ， 防止重复监听
var mObserverMap = new WeakMap();
var startListenContainer = function startListenContainer(params, callback) {
  var targetContainer = params.targetContainer;
  var newObserver = new MutationObserver(function (mutations) {
    if (mutations.length) {
      // 所有商品获取 targetGoods
      params.targetGoods = getGoodsTarget(targetContainer);
      startListenExposure(params, callback);
    }
  });
  newObserver.observe(targetContainer, {
    childList: true,
    subtree: true
  });
  mObserverMap.set(targetContainer, newObserver);
};

// 支持绑定多个 sectionId 区域
var sectionSet = new WeakSet();
// 增加参数 isBannerBarList ，以数组的形式、&做拼接，0代表没有榜单条，1代表有榜单条
function legoGoodsExposure() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  try {
    if (isServer) return;
    _log.default.info("lego\u5546\u54C1\u66DD\u5149\u57CB\u70B9lego-area-exposure");
    pageIdInfo = (0, _common.getPageIdInfo)();
    if (!pageIdInfo) {
      _log.default.error('[Lego - legoGoodsExposure] 请先配置pageId，并确保legoInit已执行');
      return;
    }
    var optsList = opts instanceof Array ? opts : [opts];
    var _iterator = _createForOfIteratorHelper(optsList),
      _step;
    try {
      var _loop = function _loop() {
        var item = _step.value;
        var params = {
          sectionId: '',
          targetContainer: undefined,
          targetGoods: []
        };
        params.sectionId = item.sectionId;
        params.extraParam = item.extraParam || {};
        if (typeof params.sectionId === 'undefined') {
          _log.default.error('[Lego - legoGoodsExposure] 初始化函数中, sectionId必须');
          return {
            v: void 0
          };
        }
        // 获取所有 section-id dom 并且监听展现
        var targetContainers = (0, _toConsumableArray2.default)(document.querySelectorAll("[".concat(SECTION_ID_NAME, "]"))).filter(function (ele) {
          return ele.getAttribute(SECTION_ID_NAME) === item.sectionId;
        });
        if (!targetContainers.length) console.error('[Lego - legoGoodsExposure] zz-sectionid 获取异常, 请检查配置');
        var _iterator2 = _createForOfIteratorHelper(targetContainers),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var targetContainer = _step2.value;
            if (sectionSet.has(targetContainer)) {
              // console.log('sectionSet has', targetContainer)
              continue;
            }
            sectionSet.add(targetContainer);
            params.targetContainer = targetContainer;
            params.targetGoods = getGoodsTarget(params.targetContainer);
            // 开始监听展现
            startListenContainer(params, callback);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ret = _loop();
        if ((0, _typeof2.default)(_ret) === "object") return _ret.v;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } catch (err) {
    _log.default.error("[Lego - legoGoodsExposure] \u521D\u59CB\u5316\u9519\u8BEF\uFF0C\u8BE6\u89C1".concat(err));
  }
}
legoGoodsExposure.getSessionId = function () {
  return rstmark;
};
legoGoodsExposure.resetSessionId = function () {
  rstmark = new Date().getTime();

  // 清空一下已经曝光过的商品以及缓存的待曝光商品
  hasExposureGoods.clear();
  // 由于支持多个区域曝光，因此保留缓存 不清除
  if (sessionIdMap.size) return;
  cachedGoodInfo.clear();
};

// 支持维护多个 sectionId 与 rstmark 对应关系
legoGoodsExposure.setSessionIdMap = function () {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 101;
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : +new Date();
  return sessionIdMap.set(key, val);
};
// 
legoGoodsExposure.getSessionIdByMap = function (key) {
  return sessionIdMap.get(key);
};

// 导出调用函数
var _default = legoGoodsExposure;
exports.default = _default;